import Drawer, { drawerClasses } from "@mui/material/Drawer";
import MenuContent from "./MenuContent";
interface SideMenuProps {
  open: boolean | undefined;
}

export default function SideMenu({ open }: SideMenuProps) {
  return (
    <Drawer
      variant="permanent"
      sx={{
        "&.MuiDrawer-root .MuiDrawer-paper": { marginTop: "80px" },
        mt: 10,
        [`& .${drawerClasses.paper}`]: {
          width: open ? 80 : 0,
        },
        width: open ? 80 : 0,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: open ? 80 : 0,
          boxShadow: "none",
          borderRight: "none",
          alignItems: "center"
        },
      }}
    >
      <MenuContent />
    </Drawer>
  );
}